import { PayloadAction } from '@reduxjs/toolkit';

import { PreviewState } from 'editor/src/store/editorModules/preview/types';

const setShowPersonalizationBarReducer = (state: PreviewState, action: PayloadAction<boolean>) => {
  state.showPersonalizationBar = action.payload;
};

export default setShowPersonalizationBarReducer;
